module.exports = __webpack_public_path__ + "static/img/11.1bbc206.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/zh/11.png
// module id = bGUT
// module chunks = 0